import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  getLastLogonUsername,
  isNativeAuthEnabled,
  isNativeAuthRegistered,
  setNativeAuthLocalStorageSettings,
  setLastLogonUsername,
} from './utils';

export interface NativeAuthState {
  isAutomaticAuthDisabled: boolean;
  isSupported: boolean;
  isEnabled: boolean;
  isRegistered: boolean;
  username?: string;
}

const initialUsername = getLastLogonUsername();

const initialState: NativeAuthState = {
  isAutomaticAuthDisabled: false,
  isSupported: false,
  isEnabled: isNativeAuthEnabled(initialUsername),
  isRegistered: isNativeAuthRegistered(initialUsername),
  username: initialUsername,
};

const nativeAuthSlice = createSlice({
  name: 'nativeAuthDialog',
  initialState,
  reducers: {
    setIsAutomaticAuthDisabled: (
      state,
      { payload }: PayloadAction<boolean>
    ) => {
      state.isAutomaticAuthDisabled = payload;
    },
    setIsSupported: (state, { payload }: PayloadAction<boolean>) => {
      state.isSupported = payload;
    },
    setIsEnabled: (state, { payload }: PayloadAction<boolean>) => {
      state.isEnabled = payload;
      setNativeAuthLocalStorageSettings(
        state.isEnabled,
        state.isRegistered,
        state.username
      );
    },
    setIsRegistered: (state, { payload }: PayloadAction<boolean>) => {
      state.isRegistered = payload;
      setNativeAuthLocalStorageSettings(
        state.isEnabled,
        state.isRegistered,
        state.username
      );
    },
    setUsername: (state, { payload }: PayloadAction<string>) => {
      state.username = payload;
      setLastLogonUsername(payload);
      state.isEnabled = isNativeAuthEnabled(payload);
      state.isRegistered = isNativeAuthRegistered(payload);
    },
  },
});

const { reducer, actions } = nativeAuthSlice;

// Actions
export const {
  setIsAutomaticAuthDisabled,
  setIsSupported,
  setIsEnabled,
  setIsRegistered,
  setUsername,
} = actions;

export const nativeAuthReducer = reducer;
